/* eslint-env browser */
/* eslint jsx-a11y/click-events-have-key-events: 0 */
/* eslint jsx-a11y/no-noninteractive-element-interactions: 0 */
/* eslint jsx-a11y/no-static-element-interactions: 0 */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { hideModal } from '@aarhus-university/au-designsystem-delphinus/source/js/components/modal-view';

const AUModalComponent = (props) => {
  const {
    domId,
    content,
    children,
    onClose,
    closeButton,
    lang,
    sender,
    className,
  } = props;

  return [
    ReactDOM.createPortal(
      <div
        key={0}
        id={domId}
        className={className}
      >
        <div className="modal-view__wrapper theme--normal">
          {
            closeButton && (
              <button
                type="button"
                className="modal-view__close button button--icon button--icon--hide-label"
                data-icon=""
                onClick={() => {
                  if (typeof onClose === 'function') {
                    onClose();
                  }
                  hideModal(domId, sender);
                }}
              >
                {lang === 'da' ? 'Luk' : 'Close'}
              </button>
            )
          }
          {children || content}
        </div>
      </div>,
      document.querySelector('body'),
    ),
  ];
};

AUModalComponent.defaultProps = {
  children: null,
  content: null,
  onClose: null,
  closeButton: true,
  lang: 'da',
  className: 'modal-view',
};

AUModalComponent.propTypes = {
  domId: PropTypes.string.isRequired,
  children: PropTypes.element,
  content: PropTypes.element,
  onClose: PropTypes.func,
  closeButton: PropTypes.bool,
  lang: PropTypes.string,
  sender: PropTypes.element.isRequired,
  className: PropTypes.string,
};

AUModalComponent.displayName = 'AUModalComponent';
export default AUModalComponent;
